import React, { useState, useEffect, useRef } from 'react';
import './ConciergeList.scss';
import {
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  InputAdornment,
  Checkbox,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CreateIcon from '@mui/icons-material/Create';
import SearchIcon from '@material-ui/icons/Search';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import {
  CONCIERGE_VIEW,
  CONCIERGE_EDIT,
  CONCIERGE_CREATE,
} from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useDispatch, useSelector } from 'react-redux';
import { allConcierge, fetchAllServiceReqeust, setConcierge } from '../../../servicesSlice';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import {
  conciergeActivate,
  conciergeDeactivate,
  deleteconcierge,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const ConciergeList = (props) => {
  const [conciergeList, setConciergeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  const searchRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dragCellWidthsRef = useRef([]);
  const dragDisabled = !!searchText || conciergeList?.length <= 1;
  const [searchButton, setSearchButton] = useState(true);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedConciergeLength) {
      setConciergeList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.group);
    handleClose();
  };

  const onViewDetails = (category, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(CONCIERGE_VIEW, true, category);
    }
  };

  const onViewDetailsIcon = (e) => {
    if (
      e.target.className ===
      'MuiButtonBase-root MuiListItem-root MuiMenuItem-root pe-4 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button'
    ) {
      onViewToggle(CONCIERGE_VIEW, true, selectedValue.group);
    }
  };

  const handleCellMenuClick = (event, item) => {
    if (selectedConciergeLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: item.id,
        name: item.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        isActive: item.isActive,
        group: item,
      });
    }
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      group: null,
      isActive: null,
    });
  };
  const originalAllConcierges = useSelector(allConcierge);
  const allConcierges = useSelector(allConcierge);

  useEffect(() => {
    setLoading(true);
    setConciergeList(
      allConcierges?.map((concierge) => {
        return {
          ...concierge,
          isChecked: false,
        };
      }),
    );
    setLoading(false);
    setSearchText('');
    setSearchButton(true);
  }, [allConcierges]);

  const getCheckedConciergeList = conciergeList?.filter((concierge) => concierge?.isChecked);
  const listOfConciergeIds = getCheckedConciergeList?.map((concierge) => concierge?.id);
  const selectedConciergeLength = getCheckedConciergeList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(conciergeList, 'isChecked');
    const filteredRows = await originalAllConcierges.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setConciergeList(updatedCheckedList);
  };

  useEffect(() => {
    updateSelectedModule(conciergeList, setActionMenuList, setIsAllSelected);
  }, [conciergeList]);

  useEffect(() => {
    if (loading || conciergeList?.length === 0) return;
    const totalItems = conciergeList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [conciergeList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleDeletePopupOpen = () => {
    handleClose();
    let currVal = { ...selectedValue };
    currVal['title'] = 'Are you sure you want to delete';
    currVal['description'] = 'This action cannot be reversed.';
    currVal.status = true;
    currVal.anchorEl = null;
    setSelectedValue(currVal);
  };

  const deleteService = async () => {
    handleClose();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      await deleteconcierge(selectedValue.id, selectedHotel, language);
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', 'Concierge deleted successfully');
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Concierge',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (!selectedValue.isActive) {
      try {
        dispatch(stepUpLoaderCount());
        await conciergeActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllServiceReqeust(selectedHotel));
        notificationManager('success', 'Concierge Activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          brand: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Concierge Activated failed',
        );
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      try {
        dispatch(stepUpLoaderCount());
        await conciergeDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllServiceReqeust(selectedHotel));
        notificationManager('success', 'Concierge Deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          brand: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Concierge Deactivated failed',
        );
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = conciergeList?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = conciergeList?.findIndex((item) => item.id === id);
    if (!conciergeList[index]?.isChecked) {
      conciergeList[index] = { ...conciergeList[index], isChecked: true };
    } else {
      conciergeList[index].isChecked = !conciergeList[index]?.isChecked;
    }
    setConciergeList([...conciergeList]);

    let actionList = conciergeList
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = conciergeList?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = conciergeList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!conciergeList[index].isChecked && !actionList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = conciergeList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((Rate_filter) => Rate_filter?.isActive);
    const isInactive = selectedMenuList?.some((Rate_filter) => !Rate_filter.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setConciergeList([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleContinue = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setConciergeList(
      originalAllConcierges?.map((item) => ({
        ...item,
        isChecked: false,
      })),
    );
    setTimeout(() => {
      searchRef?.current?.focus();
    }, 0);
  };

  const handleSearchInputFocus = (e) => {
    if (selectedConciergeLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Concierge Service',
    listOfConciergeIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CONCIERGE';
      await updateSelectedItemsStatus(
        listOfConciergeIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Concierge was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setConciergeList(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CONCIERGE';
      await deleteSelectedItems(
        listOfConciergeIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllServiceReqeust(selectedHotel));
      notificationManager('success', 'Concierge deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Concierge',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setConciergeList(ResetFilterList);
  };

  return (
    <div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteService}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <div className='row m-2 d-flex mt-4'>
        <div
          className='col-md-4'
          onClick={() => {
            visible && setPopUp(true);
          }}
        >
          <TextField
            className='w-100'
            onChange={(e) => {
              handleSearchText(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            onFocus={(e) => handleSearchInputFocus(e)}
            label='Search'
            inputRef={searchRef}
            value={searchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton className='showpopup'>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>
        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={conciergeList}
            setPlaceHolder={setConciergeList}
            globalPlaceHolder={originalAllConcierges}
            setGlobalPlaceHolder={setConcierge}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Concierge'
            module='CONCIERGE'
          />
          {permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] ===
            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, CONCIERGE_CREATE);
              }}
              className='showpopup'
            >
              Add Service
            </Button>
          )}
        </div>
      </div>
      <div ref={wrapperRef} className='row mx-2 d-flex mt-3'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          conciergeList && (
            <TableContainer className='concierge-list-table'>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow className='border-white pointer'>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedConciergeLength}
                        totalLength={allConcierges?.length}
                        inputProps={{
                          'aria-label': 'select all Concierges',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Name</TableCell>
                    <TableCell className='w-20' align='right'>
                      No.of Items
                    </TableCell>
                    <TableCell className='w-20' align='right'>
                      Max Quantity
                    </TableCell>
                    <TableCell className='w-20' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onBeforeDragStart={(start) => {
                    const rows = document.querySelectorAll('.concierge-list-table tbody tr');
                    const row = rows[start.source.index];
                    if (row) {
                      const cells = row.querySelectorAll('td');
                      dragCellWidthsRef.current = Array.from(cells).map(
                        (cell) => cell.getBoundingClientRect().width,
                      );
                    }
                  }}
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      conciergeList,
                      setConciergeList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='services' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? conciergeList.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : conciergeList
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(item, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  ...(snapshot.isDragging && { display: 'table' }),
                                }}
                              >
                                <TableCell className='w-12' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[0] } : {}}>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {!dragDisabled && (
                                      <span style={{ marginRight: 3 }}>
                                        <DragIndicator className='res-menu-accordion-drag' />
                                      </span>
                                    )}
                                    <Checkbox
                                      onChange={(event) => handleCheckboxChange(item?.id)}
                                      checked={item?.isChecked || false}
                                      inputProps={{
                                        'aria-label': `select conciergeList ${item?.id}`,
                                      }}
                                    />
                                  </div>
                                </TableCell>
                                <TableCell className='w-30' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[1] } : {}}>{item?.name}</TableCell>
                                <TableCell className='w-20' align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[2] } : {}}>
                                  {item?.isItemActive ? item?.items?.length : 'NA'}
                                </TableCell>
                                <TableCell className='w-20' align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[3] } : {}}>
                                  {item?.maxQuantityActive ? item?.maxQuantity : 'NA'}
                                </TableCell>
                                <TableCell className='w-20' align='center' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[4] } : {}}>
                                  <CustomChip
                                    label={item?.isActive ? 'Active' : 'Inactive'}
                                    color={item?.isActive ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell align='right' style={snapshot.isDragging ? { width: dragCellWidthsRef.current[5] } : {}}>
                                  {permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, item);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    disableRestoreFocus
                                    anchorEl={selectedValue?.anchorEl}
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleActivate();
                                      }}
                                    >
                                      {selectedValue.isActive ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, CONCIERGE_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onViewDetailsIcon(e);
                                      }}
                                    >
                                      <RemoveRedEyeIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleDeletePopupOpen();
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={conciergeList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedConciergeLength} ${
              selectedConciergeLength > 1 ? 'concierges' : 'concierge'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedConciergeLength}  ${
              selectedConciergeLength > 1 ? 'concierges' : 'concierge'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default ConciergeList;
